import { SimpleGrid, Box, Image, Text, Link, Container } from "@chakra-ui/react";

interface StyleAndAdviceProps {
  descriptions: Record<string, string | undefined>;
}

interface Category {
  id: number;
  name: string;
  link: string;
  desc?: string;
  image?: string;
}

export default function StyleAndAdvice({ descriptions }: StyleAndAdviceProps) {
  const categories: Category[] = [
    {
      id: 1,
      name: "Knowledge Base",
      link: "/knowledge-base",
      desc: descriptions?.knowledge_base_desc,
      image: descriptions?.knowledge_base_cover || "/images/fallback.png",
    },
    {
      id: 2,
      name: "Blogs",
      link: "/blogs",
      desc: descriptions?.blogs_desc,
      image: descriptions?.blogs_cover || "/images/fallback.png",
    },
    {
      id: 3,
      name: "Tile Trends",
      link: "/products/Tile%20Trends",
      desc: descriptions?.tile_trends_desc,
      image: descriptions?.tile_trends_cover || "/images/fallback.png",
    },
  ];

  const styeAdviceDesc = descriptions?.style_advice_desc;


  return (
    <Container maxW="1200px" py={10}>
      <Box py={10} textAlign="center">
        <Text fontSize="2xl" mb={6} fontWeight="bold">
          STYLE & ADVICE
        </Text>

        {styeAdviceDesc && (
          <Text
            fontSize="md"
            color="gray.600"
          >
            {styeAdviceDesc}
          </Text>
        )}

        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8} p={10}>
          {categories.map((cat) => (
            <Link key={cat.id} href={cat.link} _hover={{ textDecoration: "none" }}>
              <Box _hover={{ transform: "scale(1.03)" }} transition="0.3s">
                <Image
                  src={process.env.REACT_APP_API_URL+'/optimized-image'+cat.image}
                  alt={cat.name}
                  borderRadius="md"
                  w="100%"
                  h="300px"
                  objectFit="cover"
                  mb={4}
                />
                <Text fontSize="lg" fontWeight="semibold">
                  {cat.name.toUpperCase()}
                </Text>
                {cat.desc && (
                  <Text fontSize="sm" color="gray.600" mt={2}>
                    {cat.desc}
                  </Text>
                )}
              </Box>
            </Link>
          ))}
        </SimpleGrid>
      </Box>
    </Container>
  );
}
